import React from 'react';
import styles from './Calculator.module.less';

interface DisplayWindowProps {
  expression: string;
  result: string | number;
}

const DisplayWindow: React.FC<DisplayWindowProps> = ({ expression, result }) => {
  return (
    <div className={styles.displayWindow}>
      <p className={styles.expression}>{expression}</p>
      <p className={styles.result}>{result}</p>
    </div>
  );
};

export default DisplayWindow;
